import { Spinner } from "@fluentui/react";
import useAxios from "axios-hooks";
import CobrandTagsDefaultTable from "../Components/CobrandTagsDefaultTable";
import { useBoolean } from "@fluentui/react-hooks";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import DeleteCobrandTagModal from "../Components/DeleteCobrandTagModal";

function CobrandTagsDefaultPage() {
    const history = useHistory();

    const [{ data: cobrandTags, loading }, refetch] = useAxios("internal/cobrand/cobrand-tag");
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);
    const [selectedCobrandTag, setSelectedCobrandTag] = useState(null);

    useEffect(() => {
        console.log({ selectedCobrandTag });
    }, [selectedCobrandTag]);

    if (loading || !cobrandTags) {
        return <Spinner className="absolute-center" label="Loading Cobrand Tags..." />;
    }

    return (
        <>
            <CobrandTagsDefaultTable
                cobrandTags={cobrandTags}
                editOnClick={(id) => history.push(`/cobrand-settings-feature/cobrand-tags/${id}/wizard`)}
                deleteOnClick={toggleDeleteModal}
                createOnClick={() => history.push(`/cobrand-settings-feature/cobrand-tags/wizard`)}
                setSelectedCobrandTag={setSelectedCobrandTag}
            />
            {showDeleteModal && (
                <DeleteCobrandTagModal
                    showModal={showDeleteModal}
                    toggleShowModal={toggleDeleteModal}
                    cobrandTag={selectedCobrandTag}
                    onDelete={refetch}
                />
            )}
        </>
    );
}

export default CobrandTagsDefaultPage;
